<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="适用日期" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
            <!-- <el-date-picker v-model="listQuery.take_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" /> -->
          </el-form-item>
          <el-form-item label="标题" class="fn-left">
            <el-input v-model="listQuery.valuable_name" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="10" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetValuableLists">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnToParentBookDetail()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="valuable_id" align="center" />
        <el-table-column label="适用日期" align="center">
          <template slot-scope="{row}">
            {{ row.begin_date + "~" + row.end_date }}
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="valuable_name" align="center" />
        <el-table-column label="年级" prop="grade_name" align="center" />
        <el-table-column label="科目" prop="subject_name" align="center" />
        <el-table-column label="教材" prop="book_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnToParentBookDetail(row.valuable_id)">编辑</el-button>
            <el-button type="text" :loading="currentLoading == row.item_id" @click="fnDelete(row.valuable_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetValuableLists" />
    </div>

  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TiYouYouPackageList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        take_date: '',
        subject_id: '',
        grade_id: '',
        valuable_name: '',
        total: 0,
        end_date: '',
        begin_date: ''
      },
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      currentLoading: ''
    }
  },
  created() {
    this.fnGetValuableLists()
  },
  methods: {
    fnGetValuableLists: function() {
      this.bCreatePackage = false
      this.$http.tyyValuableList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.begin_date = ''
        this.listQuery.end_date = ''
        this.listQuery.time = []
      }
    },
    fnDelete(valuable_id) {
      this.$confirm('确认删除选中的日程任务么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.currentLoading = valuable_id
        this.$http.tyyDelValuable({ valuable_id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.currentLoading = ''
            this.fnGetValuableLists()
          }
        })
      })
    },
    fnToParentBookDetail: function(valuable_id) {
      this.$router.push({
        path: 'tiyouyouAddParentsBook',
        query: { id: valuable_id }
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
